import { Form } from './form.model';

export class FormTransactionLink {
  constructor(
    public id = 0,
    public form: Form = null,
    public form_version = 0,
    public input_data = '{}',
  ) {}
}
